import React from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Chip,
  LinearProgress,
  Divider,
  ToggleButton,
  ToggleButtonGroup,
  Alert,
} from "@mui/material";
import {
  PlayArrow as PlayIcon,
  Stop as StopIcon,
  EmojiEvents as TrophyIcon,
  CheckCircle as CheckIcon,
  Phone as PhoneIcon,
  Groups as GroupsIcon,
  CallSplit as SplitIcon,
  Refresh as RefreshIcon,
  PersonPin as HotSeatIcon,
  Shuffle as ShuffleIcon,
  AccessTime as TimeIcon,
  People as PeopleIcon,
  PersonOff as PersonOffIcon,
  VisibilityOff as VisibilityOffIcon,
  Leaderboard as LeaderboardIcon,
  FlashOn as FlashIcon,
  VolumeUp as VolumeUpIcon,
} from "@mui/icons-material";

const BeerillionerHostTab = (props) => {
  const {
    session,
    sessionMode,
    setSessionMode,
    setSession,
    questionSets,
    questions,
    selectedQuestionSetId,
    setSelectedQuestionSetId,
    createNewSession,
    playIntroSound,
    API_BASE,
    config,
    lifelines,
    activateLifeline,
    isRandom,
    prizes,
    maxLevel,
    getNextLevel,
    currentQuestion,
    setCurrentQuestion,
    revealResult,
    setRevealResult,
    shownOptions,
    removedOptions,
    revealedOptions,
    audienceResults,
    audienceGraphVisible,
    audienceLifelinePending,
    audienceLifelineReady,
    clueVisible,
    songNameVisible,
    quizSongs,
    selectedQuizSongId,
    selectedFFFSongId,
    fffQuizSongs,
    fffMode,
    setFffMode,
    selectedFFFQId,
    setSelectedFFFQId,
    fffStoredQuestions,
    fffQuestion,
    setFffQuestion,
    activeFFFQuestion,
    fffTimerValue,
    fffLeaderboard,
    fffLeaderboardVisible,
    fffRoundEnded,
    toggleFFFLeaderboard,
    fffPlayerCount,
    fffPlayers,
    fffHostCountdown,
    questionTimerValue,
    gameOverAdmin,
    setGameOverAdmin,
    sessionLifelines,
    audiencePlayActive,
    audiencePlayPaused,
    audiencePlayLocked,
    audiencePlayStats,
    mainSongSearch,
    setMainSongSearch,
    fffSongSearch,
    setFffSongSearch,
    df,
    startFFFIntro,
    startFFF,
    loadFFFSongs,
    loadFFFLeaderboard,
    doShowOption,
    doShowAllOptions,
    doHideOption,
    doStartFFFTimer,
    highlightAnswer,
    doStartTimer,
    doRevealAnswer,
    doWalkAway,
    loadQuizSongs,
    pushQuizQuestion,
    pushQuestionToGame,
    selectHotSeat,
    handleNextQuizSameSong,
    handleNextQuizNewSong,
    handleNextQ,
    toggleAudienceGraph,
    toggleClueVisibility,
    toggleSongNameVisibility,
    resumeAudiencePlay,
    endGame,
    setAudienceModalOpen,
    setSelectedQuizSongId,
    setSelectedFFFSongId,
  } = props;

  return (
          <Box>
            {!session || session.status === "ended" ? (
              <Paper sx={{ p: 3, bgcolor: "#1a1a1a" }}>
                <Typography sx={{ color: "#aaa", mb: 2, textAlign: "center" }}>
                  No active game session
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                  }}>
                  <ToggleButtonGroup
                    value={sessionMode}
                    exclusive
                    onChange={(_, v) => v && setSessionMode(v)}
                    size="small">
                    <ToggleButton
                      value="preset"
                      sx={{
                        color: "#aaa",
                        px: 3,
                        "&.Mui-selected": {
                          color: "#ffd700",
                          bgcolor: "rgba(255,215,0,0.1)",
                        },
                      }}>
                      Pre-select
                    </ToggleButton>
                    <ToggleButton
                      value="random"
                      sx={{
                        color: "#aaa",
                        px: 3,
                        "&.Mui-selected": {
                          color: "#e65100",
                          bgcolor: "rgba(230,81,0,0.1)",
                        },
                      }}>
                      <ShuffleIcon sx={{ mr: 0.5, fontSize: 18 }} />
                      Random
                    </ToggleButton>
                  </ToggleButtonGroup>
                  {sessionMode === "preset" && questionSets.length > 0 && (
                    <FormControl
                      size="small"
                      sx={{ minWidth: 250 }}>
                      <InputLabel sx={{ color: "#aaa" }}>
                        Question Set
                      </InputLabel>
                      <Select
                        value={selectedQuestionSetId}
                        onChange={(e) =>
                          setSelectedQuestionSetId(e.target.value)
                        }
                        label="Question Set"
                        sx={{
                          color: "#fff",
                          "& fieldset": { borderColor: "#555" },
                        }}>
                        <MenuItem value="">All Questions</MenuItem>
                        {questionSets.map((s) => (
                          <MenuItem
                            key={s.id}
                            value={s.id}>
                            {s.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                  {sessionMode === "random" && (
                    <Alert
                      severity="info"
                      sx={{
                        bgcolor: "rgba(25,118,210,0.1)",
                        color: "#90caf9",
                      }}>
                      Random mode: questions auto-picked per level based on
                      topic &amp; difficulty in Prize Ladder config.
                    </Alert>
                  )}
                  <Button
                    variant="outlined"
                    startIcon={<VolumeUpIcon />}
                    onClick={playIntroSound}
                    size="large"
                    sx={{
                      color: "#ffd700",
                      borderColor: "rgba(255,215,0,0.5)",
                      "&:hover": {
                        borderColor: "#ffd700",
                        bgcolor: "rgba(255,215,0,0.08)",
                      },
                      px: 4,
                    }}>
                    Intro Sound
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<PlayIcon />}
                    onClick={createNewSession}
                    size="large"
                    sx={{
                      bgcolor: "#ffd700",
                      color: "#000",
                      "&:hover": { bgcolor: "#e6c200" },
                      px: 4,
                    }}>
                    Start New Game
                  </Button>
                </Box>
              </Paper>
            ) : (
              <Grid
                container
                spacing={2}>
                {/* Left */}
                <Grid
                  item
                  xs={12}
                  md={3}
                  sx={{ order: { xs: 2, md: 1 }, display: "flex", flexDirection: "column" }}>
                  <Paper sx={{ p: 2, bgcolor: "#1a1a1a", order: { xs: 2, md: 1 }, mb: 2 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "#ffd700", mb: 1 }}>
                      Prize Ladder{" "}
                      {isRandom && (
                        <Chip
                          label="Random"
                          size="small"
                          sx={{ bgcolor: "#e65100", color: "#fff", ml: 1 }}
                        />
                      )}
                    </Typography>
                    {[...prizes].reverse().map((p) => {
                      const isCur = session?.current_level === p.level;
                      return (
                        <Box
                          key={p.id}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            py: 0.5,
                            px: 1,
                            borderRadius: 1,
                            bgcolor: isCur
                              ? "rgba(255,215,0,0.2)"
                              : "transparent",
                            border: isCur
                              ? "1px solid #ffd700"
                              : "1px solid transparent",
                          }}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: isCur
                                ? "#ffd700"
                                : p.is_checkpoint
                                  ? "#b8860b"
                                  : "#888",
                              fontWeight: isCur ? 700 : 400,
                              minWidth: 20,
                            }}>
                            {p.level}
                          </Typography>
                          {p.image_url && (
                            <Box
                              component="img"
                              src={
                                p.image_url.startsWith("http")
                                  ? p.image_url
                                  : `${API_BASE}/${p.image_url}`
                              }
                              sx={{
                                width: 20,
                                height: 20,
                                borderRadius: 0.5,
                                objectFit: "cover",
                              }}
                            />
                          )}
                          <Typography
                            variant="caption"
                            noWrap
                            sx={{ color: isCur ? "#ffd700" : "#ccc", flex: 1 }}>
                            {p.label}
                          </Typography>
                          {p.is_checkpoint && (
                            <TrophyIcon
                              sx={{ fontSize: 14, color: "#b8860b" }}
                            />
                          )}
                        </Box>
                      );
                    })}
                  </Paper>
                  <Paper sx={{ p: 2, bgcolor: "#1a1a1a", order: { xs: 1, md: 2 } }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "#ffd700", mb: 1 }}>
                      Lifelines
                    </Typography>
                    {lifelines
                      .filter((l) => l.is_enabled)
                      .map((ll) => {
                        const avail = sessionLifelines.includes(ll.type);
                        const IC =
                          ll.type === "50_50"
                            ? SplitIcon
                            : ll.type === "ask_audience"
                              ? GroupsIcon
                              : PhoneIcon;
                        return (
                          <Button
                            key={ll.id}
                            fullWidth
                            variant={avail ? "outlined" : "text"}
                            disabled={!avail || session.status !== "main_game"}
                            startIcon={<IC />}
                            onClick={() => activateLifeline(ll.type)}
                            sx={{
                              mb: 1,
                              color: avail ? "#ffd700" : "#555",
                              borderColor: avail ? "#ffd700" : "#333",
                              justifyContent: "flex-start",
                              textTransform: "none",
                            }}>
                            {ll.label}
                          </Button>
                        );
                      })}
                    {audienceLifelinePending && (
                      <Box sx={{ mt: 1, p: 1, bgcolor: "rgba(255,215,0,0.1)", border: "1px solid #ffd700", borderRadius: 1 }}>
                        <Typography variant="caption" sx={{ color: "#ffd700", fontWeight: 700 }}>
                          Ask the Audience — waiting for audience timer to end...
                        </Typography>
                      </Box>
                    )}
                    {audienceLifelineReady && audienceResults && (
                      <Box sx={{ mt: 1 }}>
                        <Typography variant="caption" sx={{ color: "#aaa" }}>
                          Audience Results ({audienceResults.total_votes} votes)
                        </Typography>
                        {["A", "B", "C", "D"]
                          .filter((o) => !removedOptions.includes(o))
                          .map((o) => (
                            <Box key={o} sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                              <Typography variant="caption" sx={{ color: "#fff", minWidth: 14 }}>{o}</Typography>
                              <LinearProgress variant="determinate" value={audienceResults.percentages?.[o] || 0}
                                sx={{ flex: 1, height: 8, borderRadius: 4, bgcolor: "#333", "& .MuiLinearProgress-bar": { bgcolor: "#ffd700" } }} />
                              <Typography variant="caption" sx={{ color: "#ffd700", minWidth: 30, textAlign: "right" }}>
                                {audienceResults.percentages?.[o] || 0}%
                              </Typography>
                            </Box>
                          ))}
                        <Button
                          fullWidth
                          variant="contained"
                          onClick={() => toggleAudienceGraph(!audienceGraphVisible)}
                          sx={{ mt: 1, bgcolor: audienceGraphVisible ? "#e91e63" : "#4caf50", "&:hover": { bgcolor: audienceGraphVisible ? "#c2185b" : "#388e3c" } }}>
                          {audienceGraphVisible ? "Hide Graph from Player" : "Show Graph to Player"}
                        </Button>
                      </Box>
                    )}
                  </Paper>
                  {config?.audience_play_enabled &&
                    session.status === "main_game" && (
                      <Paper sx={{ p: 2, bgcolor: "#1a1a1a", mt: 2, order: { xs: 3, md: 3 } }}>
                        <Typography
                          variant="subtitle2"
                          sx={{ color: "#e040fb", mb: 1 }}>
                          Audience Play
                        </Typography>
                        {audiencePlayActive && (
                          <Chip
                            label="LIVE"
                            size="small"
                            sx={{ bgcolor: "#e040fb", color: "#fff", mb: 1 }}
                          />
                        )}
                        {audiencePlayPaused && (
                          <Box>
                            <Chip
                              label="PAUSED"
                              size="small"
                              sx={{ bgcolor: "#ff9800", color: "#fff", mb: 1 }}
                            />
                            <Button
                              fullWidth
                              variant="contained"
                              onClick={resumeAudiencePlay}
                              sx={{
                                mt: 1,
                                bgcolor: "#e040fb",
                                "&:hover": { bgcolor: "#ab47bc" },
                              }}>
                              Resume Audience Timer
                            </Button>
                          </Box>
                        )}
                        {audiencePlayLocked && (
                          <Chip
                            label="LOCKED"
                            size="small"
                            sx={{ bgcolor: "#ef5350", color: "#fff", mb: 1 }}
                          />
                        )}
                        {!audiencePlayActive &&
                          !audiencePlayPaused &&
                          !audiencePlayLocked &&
                          shownOptions.length === 4 && (
                            <Typography
                              variant="caption"
                              sx={{ color: "#888", display: "block", mb: 1 }}>
                              Audience timer starts together with the main
                              question timer.
                            </Typography>
                          )}
                        {audiencePlayStats && (
                          <Box sx={{ mt: 1 }}>
                            <Typography
                              variant="caption"
                              sx={{ color: "#aaa" }}>
                              Audience Play ({audiencePlayStats.total_answers}{" "}
                              answers)
                            </Typography>
                            {["A", "B", "C", "D"]
                              .filter((o) => !removedOptions.includes(o))
                              .map((o) => (
                                <Box
                                  key={o}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    mt: 0.5,
                                  }}>
                                  <Typography
                                    variant="caption"
                                    sx={{ color: "#fff", minWidth: 14 }}>
                                    {o}
                                  </Typography>
                                  <LinearProgress
                                    variant="determinate"
                                    value={
                                      audiencePlayStats.percentages?.[o] || 0
                                    }
                                    sx={{
                                      flex: 1,
                                      height: 8,
                                      borderRadius: 4,
                                      bgcolor: "#333",
                                      "& .MuiLinearProgress-bar": {
                                        bgcolor: "#e040fb",
                                      },
                                    }}
                                  />
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#e040fb",
                                      minWidth: 30,
                                      textAlign: "right",
                                    }}>
                                    {audiencePlayStats.percentages?.[o] || 0}%
                                  </Typography>
                                </Box>
                              ))}
                          </Box>
                        )}
                      </Paper>
                    )}
                </Grid>

                {/* Center */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ order: { xs: 1, md: 2 } }}>
                  <Paper
                    sx={{
                      p: 3,
                      bgcolor: "#0d1b2a",
                      border: "2px solid #ffd700",
                      borderRadius: 2,
                      minHeight: 400,
                    }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 2,
                      }}>
                      <Chip
                        label={`Status: ${session.status}`}
                        sx={{
                          bgcolor:
                            session.status === "main_game"
                              ? "#2e7d32"
                              : session.status === "fff"
                                ? "#1565c0"
                                : session.status === "fff_intro"
                                  ? "#6a1b9a"
                                  : "#555",
                          color: "#fff",
                        }}
                      />
                      {session.hot_seat_display_name && (
                        <Chip
                          icon={<HotSeatIcon />}
                          label={session.hot_seat_display_name}
                          sx={{ bgcolor: "#b8860b", color: "#fff" }}
                        />
                      )}
                      <Button
                        size="small"
                        variant="outlined"
                        startIcon={<PeopleIcon sx={{ fontSize: 16 }} />}
                        onClick={() => setAudienceModalOpen(true)}
                        sx={{
                          color: "#e040fb",
                          borderColor: "#e040fb",
                          textTransform: "none",
                          fontWeight: 600,
                          ml: "auto",
                          "&:hover": {
                            borderColor: "#f3e5f5",
                            bgcolor: "rgba(224,64,251,0.08)",
                          },
                        }}
                      >
                        Audience Results
                      </Button>
                    </Box>

                    {/* FFF */}
                    {(session.status === "idle" ||
                      session.status === "fff_intro" ||
                      session.status === "fff") && (
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            mb: 2,
                          }}>
                          <Typography
                            variant="h6"
                            sx={{ color: "#ffd700" }}>
                            Fastest Finger First
                          </Typography>
                          <Chip
                            icon={
                              <PeopleIcon
                                sx={{ color: "#fff !important", fontSize: 16 }}
                              />
                            }
                            label={`${fffPlayerCount} Player${fffPlayerCount !== 1 ? "s" : ""} Online`}
                            size="small"
                            sx={{
                              bgcolor: "rgba(41,182,246,0.15)",
                              color: "#29b6f6",
                              fontWeight: 600,
                              "& .MuiChip-icon": { ml: 0.5 },
                            }}
                          />
                        </Box>
                        <ToggleButtonGroup
                          value={fffMode}
                          exclusive
                          onChange={(_, v) => v && setFffMode(v)}
                          size="small"
                          sx={{ mb: 2 }}>
                          <ToggleButton
                            value="manual"
                            sx={{
                              color: "#aaa",
                              "&.Mui-selected": {
                                color: "#ffd700",
                                bgcolor: "rgba(255,215,0,0.1)",
                              },
                            }}>
                            Manual
                          </ToggleButton>
                          <ToggleButton
                            value="stored"
                            sx={{
                              color: "#aaa",
                              "&.Mui-selected": {
                                color: "#ffd700",
                                bgcolor: "rgba(255,215,0,0.1)",
                              },
                            }}>
                            Pre-stored
                          </ToggleButton>
                          <ToggleButton
                            value="random"
                            sx={{
                              color: "#aaa",
                              "&.Mui-selected": {
                                color: "#e65100",
                                bgcolor: "rgba(230,81,0,0.1)",
                              },
                            }}>
                            <ShuffleIcon sx={{ mr: 0.5, fontSize: 18 }} />
                            Random
                          </ToggleButton>
                        </ToggleButtonGroup>
                        {fffMode === "manual" && (
                          <>
                            <TextField
                              fullWidth
                              multiline
                              rows={2}
                              label="FFF Question"
                              value={fffQuestion.question_text}
                              onChange={(e) =>
                                setFffQuestion((p) => ({
                                  ...p,
                                  question_text: e.target.value,
                                }))
                              }
                              sx={{ mb: 1, ...df }}
                            />
                            <Grid
                              container
                              spacing={1}>
                              {["A", "B", "C", "D"].map((o) => (
                                <Grid
                                  item
                                  xs={6}
                                  key={o}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    label={`Option ${o}`}
                                    value={
                                      fffQuestion[`option_${o.toLowerCase()}`]
                                    }
                                    onChange={(e) =>
                                      setFffQuestion((p) => ({
                                        ...p,
                                        [`option_${o.toLowerCase()}`]:
                                          e.target.value,
                                      }))
                                    }
                                    sx={df}
                                  />
                                </Grid>
                              ))}
                            </Grid>
                            <FormControl
                              size="small"
                              sx={{ mt: 1, minWidth: 150 }}>
                              <InputLabel sx={{ color: "#aaa" }}>
                                Correct
                              </InputLabel>
                              <Select
                                value={fffQuestion.correct_answer}
                                onChange={(e) =>
                                  setFffQuestion((p) => ({
                                    ...p,
                                    correct_answer: e.target.value,
                                  }))
                                }
                                label="Correct"
                                sx={{
                                  color: "#fff",
                                  "& fieldset": { borderColor: "#555" },
                                }}>
                                {["A", "B", "C", "D"].map((o) => (
                                  <MenuItem
                                    key={o}
                                    value={o}>
                                    {o}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </>
                        )}
                        {fffMode === "stored" && (
                          <Box>
                            <FormControl
                              fullWidth
                              size="small"
                              sx={{ mb: 1 }}>
                              <InputLabel sx={{ color: "#aaa" }}>
                                Select FFF Question
                              </InputLabel>
                              <Select
                                value={selectedFFFQId}
                                onChange={(e) =>
                                  setSelectedFFFQId(e.target.value)
                                }
                                label="Select FFF Question"
                                sx={{
                                  color: "#fff",
                                  "& fieldset": { borderColor: "#555" },
                                }}>
                                {fffStoredQuestions.map((q) => (
                                  <MenuItem
                                    key={q.id}
                                    value={q.id}>
                                    {q.question_text.substring(0, 80)}
                                    {q.question_text.length > 80 ? "..." : ""}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            {selectedFFFQId &&
                              (() => {
                                const q = fffStoredQuestions.find(
                                  (f) => f.id === parseInt(selectedFFFQId),
                                );
                                if (!q) return null;
                                return (
                                  <Box
                                    sx={{
                                      p: 1.5,
                                      bgcolor: "#1a2a3a",
                                      borderRadius: 1,
                                      mb: 1,
                                    }}>
                                    <Typography sx={{ color: "#fff", mb: 1 }}>
                                      {q.question_text}
                                    </Typography>
                                    {["A", "B", "C", "D"].map((o) => (
                                      <Typography
                                        key={o}
                                        variant="body2"
                                        sx={{
                                          color:
                                            q.correct_answer === o
                                              ? "#4caf50"
                                              : "#aaa",
                                        }}>
                                        {o}: {q[`option_${o.toLowerCase()}`]}
                                        {q.correct_answer === o ? " ✓" : ""}
                                      </Typography>
                                    ))}
                                  </Box>
                                );
                              })()}
                          </Box>
                        )}
                        {fffMode === "random" &&
                          (() => {
                            if (fffQuizSongs.length === 0) loadFFFSongs();
                            const filtered = fffQuizSongs.filter((s) => {
                              if (!fffSongSearch) return true;
                              const q = fffSongSearch.toLowerCase();
                              return (
                                (s.name || "").toLowerCase().includes(q) ||
                                (s.artist || "").toLowerCase().includes(q)
                              );
                            });
                            return (
                              <Box
                                sx={{
                                  p: 2,
                                  bgcolor: "#1a2a3a",
                                  borderRadius: 1,
                                  mb: 1,
                                }}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{ color: "#ffd700", mb: 1 }}>
                                  Pick a song from Quiz Bank (or push random
                                  from all)
                                </Typography>
                                <TextField
                                  fullWidth
                                  size="small"
                                  placeholder="Search songs..."
                                  value={fffSongSearch}
                                  onChange={(e) =>
                                    setFffSongSearch(e.target.value)
                                  }
                                  sx={{ mb: 1, ...df }}
                                />
                                <Box
                                  sx={{
                                    maxHeight: 200,
                                    overflowY: "auto",
                                    border: "1px solid #333",
                                    borderRadius: 1,
                                    p: 1,
                                    bgcolor: "#1a1a1a",
                                  }}>
                                  {filtered.length === 0 ? (
                                    <Typography
                                      sx={{
                                        color: "#888",
                                        textAlign: "center",
                                        py: 2,
                                      }}>
                                      {fffQuizSongs.length === 0
                                        ? "Loading songs..."
                                        : "No songs match"}
                                    </Typography>
                                  ) : (
                                    filtered.map((s) => (
                                      <Button
                                        key={s.songs_master_id}
                                        fullWidth
                                        variant={
                                          selectedFFFSongId ===
                                          String(s.songs_master_id)
                                            ? "contained"
                                            : "text"
                                        }
                                        onClick={() =>
                                          setSelectedFFFSongId((prev) =>
                                            prev === String(s.songs_master_id)
                                              ? ""
                                              : String(s.songs_master_id),
                                          )
                                        }
                                        sx={{
                                          justifyContent: "flex-start",
                                          textTransform: "none",
                                          color:
                                            selectedFFFSongId ===
                                            String(s.songs_master_id)
                                              ? "#000"
                                              : "#fff",
                                          mb: 0.5,
                                          bgcolor:
                                            selectedFFFSongId ===
                                            String(s.songs_master_id)
                                              ? "#ffd700"
                                              : "transparent",
                                        }}>
                                        {s.image && (
                                          <Box
                                            component="img"
                                            src={
                                              s.image.startsWith("http")
                                                ? s.image
                                                : `${API_BASE}/${s.image}`
                                            }
                                            sx={{
                                              width: 28,
                                              height: 28,
                                              borderRadius: 0.5,
                                              objectFit: "cover",
                                              mr: 1,
                                            }}
                                          />
                                        )}
                                        <Typography
                                          noWrap
                                          sx={{ flex: 1, textAlign: "left" }}>
                                          {s.name}{" "}
                                          {s.artist ? `— ${s.artist}` : ""}
                                        </Typography>
                                        <Chip
                                          label={s.question_count}
                                          size="small"
                                          sx={{
                                            bgcolor: "#333",
                                            color: "#aaa",
                                            fontSize: "0.7rem",
                                          }}
                                        />
                                      </Button>
                                    ))
                                  )}
                                </Box>
                              </Box>
                            );
                          })()}
                        <Box
                          sx={{
                            mt: 2,
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                          }}>
                          <Button
                            variant="outlined"
                            startIcon={<FlashIcon />}
                            onClick={startFFFIntro}
                            sx={{
                              color: "#ffd700",
                              borderColor: "#ffd700",
                              fontWeight: 700,
                              "&:hover": {
                                borderColor: "#ffe57f",
                                bgcolor: "rgba(255,215,0,0.08)",
                              },
                            }}>
                            Intro FFF
                          </Button>
                          {session.status === "fff_intro" && (
                            <Typography
                              variant="caption"
                              sx={{ color: "#ce93d8", textAlign: "center" }}>
                              Intro playing on player screens
                            </Typography>
                          )}
                          <Box sx={{ display: "flex", gap: 1 }}>
                            <Button
                              variant="contained"
                              startIcon={
                                fffMode === "random" ? (
                                  <ShuffleIcon />
                                ) : (
                                  <PlayIcon />
                                )
                              }
                              onClick={startFFF}
                              disabled={
                                fffMode === "stored"
                                  ? !selectedFFFQId
                                  : fffMode === "manual"
                                    ? !fffQuestion.question_text
                                    : fffQuizSongs.length === 0
                              }
                              sx={{
                                bgcolor:
                                  fffMode === "random" ? "#e65100" : "#ffd700",
                                color: "#fff",
                              }}>
                              {fffMode === "random"
                                ? selectedFFFSongId
                                  ? "Push from Song"
                                  : "Push Random FFF"
                                : "Push FFF"}
                            </Button>
                            <Button
                              variant="outlined"
                              startIcon={<RefreshIcon />}
                              onClick={loadFFFLeaderboard}
                              sx={{ color: "#ffd700", borderColor: "#ffd700" }}>
                              Refresh
                            </Button>
                          </Box>
                        </Box>
                        {activeFFFQuestion && (
                          <Box
                            sx={{
                              mt: 2,
                              p: 2,
                              bgcolor: "#0d2137",
                              borderRadius: 1,
                              border: "1px solid #29b6f6",
                            }}>
                            <Typography
                              variant="subtitle2"
                              sx={{ color: "#29b6f6", mb: 1 }}>
                              Show Options to Users
                            </Typography>
                            {fffHostCountdown > 0 ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  py: 3,
                                  mb: 2,
                                }}>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: "#4fc3f7",
                                    letterSpacing: 2,
                                    mb: 1,
                                  }}>
                                  GET READY
                                </Typography>
                                <Typography
                                  variant="h1"
                                  sx={{
                                    color: "#ffd700",
                                    fontWeight: 800,
                                    fontSize: { xs: "5rem", sm: "7rem" },
                                    lineHeight: 1,
                                    textShadow:
                                      "0 0 40px rgba(255,215,0,0.45)",
                                  }}>
                                  {fffHostCountdown}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{ color: "#888", mt: 1 }}>
                                  Synced with players — same 3s countdown
                                </Typography>
                              </Box>
                            ) : (
                              <Typography sx={{ color: "#fff", mb: 2 }}>
                                {activeFFFQuestion.question_text}
                              </Typography>
                            )}
                            {fffHostCountdown <= 0 && fffTimerValue != null && (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: 1,
                                  mb: 2,
                                }}>
                                <TimeIcon
                                  sx={{
                                    color:
                                      fffTimerValue <= 5
                                        ? "#ef5350"
                                        : "#29b6f6",
                                  }}
                                />
                                <Typography
                                  variant="h4"
                                  sx={{
                                    color:
                                      fffTimerValue <= 5
                                        ? "#ef5350"
                                        : "#29b6f6",
                                    fontWeight: 700,
                                  }}>
                                  {fffTimerValue}s
                                </Typography>
                              </Box>
                            )}
                            {fffHostCountdown <= 0 && (
                              <>
                                <Box sx={{ mb: 1.5, textAlign: "center" }}>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    disabled={shownOptions.length >= 4}
                                    onClick={doShowAllOptions}
                                    sx={{
                                      bgcolor: "#1565c0",
                                      fontSize: "0.8rem",
                                      px: 2.5,
                                      "&:hover": { bgcolor: "#0d47a1" },
                                    }}>
                                    Show All & Start Timer
                                  </Button>
                                </Box>
                                <Grid
                                  container
                                  spacing={1}>
                                  {["A", "B", "C", "D"].map((opt) => {
                                    const isShown = shownOptions.includes(opt);
                                    const isCorrect =
                                      activeFFFQuestion.correct_answer === opt;
                                    return (
                                      <Grid
                                        item
                                        xs={6}
                                        key={opt}>
                                        <Box
                                          sx={{
                                            p: 1,
                                            bgcolor: isShown
                                              ? isCorrect
                                                ? "rgba(76,175,80,0.15)"
                                                : "#1a3a5c"
                                              : "#111",
                                            border: `1px solid ${isShown ? (isCorrect ? "#4caf50" : "#29b6f6") : "#333"}`,
                                            borderRadius: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            position: "relative",
                                          }}>
                                          {isCorrect && (
                                            <Chip
                                              label="Correct"
                                              size="small"
                                              sx={{
                                                position: "absolute",
                                                top: -10,
                                                right: 8,
                                                bgcolor: "#4caf50",
                                                color: "#fff",
                                                fontSize: "0.65rem",
                                                height: 18,
                                                fontWeight: 700,
                                                "& .MuiChip-label": {
                                                  px: 0.8,
                                                },
                                              }}
                                            />
                                          )}
                                          <Typography
                                            sx={{
                                              color: "#ffd700",
                                              fontWeight: 700,
                                              minWidth: 18,
                                            }}>
                                            {opt}:
                                          </Typography>
                                          <Typography
                                            sx={{
                                              color: "#fff",
                                              flex: 1,
                                              fontSize: "0.85rem",
                                            }}
                                            noWrap>
                                            {
                                              activeFFFQuestion[
                                                `option_${opt.toLowerCase()}`
                                              ]
                                            }
                                          </Typography>
                                          {!isShown ? (
                                            <Button
                                              size="small"
                                              variant="contained"
                                              onClick={() => doShowOption(opt)}
                                              sx={{
                                                bgcolor: "#1565c0",
                                                minWidth: 50,
                                                fontSize: "0.7rem",
                                              }}>
                                              Show
                                            </Button>
                                          ) : (
                                            <Button
                                              size="small"
                                              variant="outlined"
                                              onClick={() => doHideOption(opt)}
                                              sx={{
                                                minWidth: 50,
                                                fontSize: "0.7rem",
                                                color: "#ef9a9a",
                                                borderColor: "#e57373",
                                              }}>
                                              Hide
                                            </Button>
                                          )}
                                        </Box>
                                      </Grid>
                                    );
                                  })}
                                </Grid>
                                {shownOptions.length > 0 &&
                                  fffTimerValue == null && (
                                    <Box sx={{ mt: 2, textAlign: "center" }}>
                                      <Button
                                        variant="contained"
                                        startIcon={<TimeIcon />}
                                        onClick={doStartFFFTimer}
                                        sx={{
                                          bgcolor: "#e65100",
                                          color: "#fff",
                                          px: 4,
                                          py: 1,
                                          fontSize: "1rem",
                                          "&:hover": { bgcolor: "#bf360c" },
                                        }}>
                                        Start Timer (
                                        {config?.fff_timer_seconds || 30}s)
                                      </Button>
                                    </Box>
                                  )}
                              </>
                            )}
                          </Box>
                        )}
                      </Box>
                    )}

                    {/* Main Game */}
                    {session.status === "main_game" && (
                      <Box>
                        {currentQuestion ||
                        session.current_question_id ||
                        session.current_quiz_question_id ? (
                          <Box>
                            <Typography
                              variant="h6"
                              sx={{ color: "#fff", mb: 2 }}>
                              {currentQuestion?.question_text || "Loading..."}
                            </Typography>

                            {isRandom && (currentQuestion?.question_clue || currentQuestion?.song_name) && (
                              <Box sx={{ mb: 2, display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
                                {currentQuestion?.question_clue && (
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, bgcolor: clueVisible ? "rgba(255,152,0,0.15)" : "rgba(255,255,255,0.05)", border: `1px solid ${clueVisible ? "#ff9800" : "#555"}`, borderRadius: 1, px: 1.5, py: 0.5 }}>
                                    <Typography sx={{ color: "#ff9800", fontSize: "0.8rem", fontWeight: 700 }}>Clue:</Typography>
                                    <Typography sx={{ color: "#fff", fontSize: "0.8rem" }}>{currentQuestion.question_clue}</Typography>
                                    <Button size="small" variant={clueVisible ? "contained" : "outlined"} onClick={toggleClueVisibility}
                                      sx={{ ml: 1, minWidth: 60, fontSize: "0.7rem", bgcolor: clueVisible ? "#e65100" : "transparent", color: clueVisible ? "#fff" : "#ff9800", borderColor: "#ff9800", "&:hover": { bgcolor: clueVisible ? "#bf360c" : "rgba(255,152,0,0.1)" } }}>
                                      {clueVisible ? "Hide" : "Show"}
                                    </Button>
                                  </Box>
                                )}
                                {currentQuestion?.song_name && (
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, bgcolor: songNameVisible ? "rgba(41,182,246,0.15)" : "rgba(255,255,255,0.05)", border: `1px solid ${songNameVisible ? "#29b6f6" : "#555"}`, borderRadius: 1, px: 1.5, py: 0.5 }}>
                                    <Typography sx={{ color: "#29b6f6", fontSize: "0.8rem", fontWeight: 700 }}>Song:</Typography>
                                    <Typography sx={{ color: "#fff", fontSize: "0.8rem" }}>{currentQuestion.song_name}</Typography>
                                    <Button size="small" variant={songNameVisible ? "contained" : "outlined"} onClick={toggleSongNameVisibility}
                                      sx={{ ml: 1, minWidth: 60, fontSize: "0.7rem", bgcolor: songNameVisible ? "#0277bd" : "transparent", color: songNameVisible ? "#fff" : "#29b6f6", borderColor: "#29b6f6", "&:hover": { bgcolor: songNameVisible ? "#01579b" : "rgba(41,182,246,0.1)" } }}>
                                      {songNameVisible ? "Hide" : "Show"}
                                    </Button>
                                  </Box>
                                )}
                              </Box>
                            )}

                            {/* Show options first, then run timer, select final answer, and reveal */}
                            {questionTimerValue != null && (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: 1,
                                  mb: 2,
                                }}>
                                <TimeIcon
                                  sx={{
                                    color:
                                      questionTimerValue <= 5
                                        ? "#ef5350"
                                        : "#ffd700",
                                  }}
                                />
                                <Typography
                                  variant="h4"
                                  sx={{
                                    color:
                                      questionTimerValue <= 5
                                        ? "#ef5350"
                                        : "#ffd700",
                                    fontWeight: 700,
                                  }}>
                                  {questionTimerValue}s
                                </Typography>
                              </Box>
                            )}
                            {(() => {
                              const remainingOpts = ["A", "B", "C", "D"].filter(
                                (opt) => !removedOptions.includes(opt),
                              );
                              const allOptionsShown = remainingOpts.every(
                                (opt) => shownOptions.includes(opt),
                              );
                              const canSelectAnswer =
                                allOptionsShown &&
                                !revealResult &&
                                ((questionTimerValue || 0) > 0 ||
                                  (config?.question_timer_seconds || 0) <= 0);
                              return (
                                <>
                                <Box sx={{ mb: 1.5, textAlign: "center" }}>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    disabled={allOptionsShown || !!revealResult}
                                    onClick={doShowAllOptions}
                                    sx={{
                                      bgcolor: "#1565c0",
                                      fontSize: "0.8rem",
                                      px: 2.5,
                                      "&:hover": { bgcolor: "#0d47a1" },
                                    }}>
                                    Show All
                                  </Button>
                                </Box>
                                <Grid
                                  container
                                  spacing={1}>
                                  {remainingOpts
                                    .map((opt) => {
                                      const optKey = `option_${opt.toLowerCase()}`;
                                      const isShown =
                                        shownOptions.includes(opt);
                                      const isCorrectOpt =
                                        (currentQuestion?.correct_answer ||
                                          revealResult?.correct_answer) === opt;
                                      const isH =
                                        session.highlighted_answer === opt;
                                      const isR =
                                        revealResult?.correct_answer === opt;
                                      const isW =
                                        revealResult &&
                                        !revealResult.is_correct &&
                                        revealResult.highlighted_answer !==
                                          revealResult.correct_answer &&
                                        session.highlighted_answer === opt;
                                      const isRevealedCorrect =
                                        revealedOptions[opt] === true;
                                      const isRevealedWrong =
                                        revealedOptions[opt] === false;
                                      let bg = isShown
                                        ? isCorrectOpt && !revealResult
                                          ? "rgba(76,175,80,0.12)"
                                          : "#1a2a3a"
                                        : "#111";
                                      let border = isShown
                                        ? isCorrectOpt && !revealResult
                                          ? "#4caf50"
                                          : "#29b6f6"
                                        : "#333";
                                      if (isW) {
                                        bg = "#c62828";
                                        border = "#ef5350";
                                      } else if (
                                        (isR && revealResult) ||
                                        isRevealedCorrect
                                      ) {
                                        bg = "#2e7d32";
                                        border = "#4caf50";
                                      } else if (isRevealedWrong) {
                                        bg = "#555";
                                        border = "#555";
                                      } else if (isH) {
                                        bg = "#b8860b";
                                        border = "#ff9800";
                                      }
                                      return (
                                        <Grid
                                          item
                                          xs={6}
                                          key={opt}>
                                          <Box
                                            onClick={
                                              canSelectAnswer && isShown
                                                ? () => highlightAnswer(opt)
                                                : undefined
                                            }
                                            sx={{
                                              p: 1.5,
                                              bgcolor: bg,
                                              border: `2px solid ${border}`,
                                              borderRadius: 1,
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                              opacity: isRevealedWrong
                                                ? 0.5
                                                : 1,
                                              transition: "all 0.3s",
                                              position: "relative",
                                              cursor:
                                                canSelectAnswer && isShown
                                                  ? "pointer"
                                                  : "default",
                                              "&:hover":
                                                canSelectAnswer && isShown
                                                  ? {
                                                      filter: "brightness(1.1)",
                                                    }
                                                  : {},
                                            }}>
                                            {isCorrectOpt && (
                                              <Chip
                                                label="Correct"
                                                size="small"
                                                sx={{
                                                  position: "absolute",
                                                  top: -10,
                                                  right: 8,
                                                  bgcolor: "#4caf50",
                                                  color: "#fff",
                                                  fontSize: "0.65rem",
                                                  height: 18,
                                                  fontWeight: 700,
                                                  "& .MuiChip-label": {
                                                    px: 0.8,
                                                  },
                                                  zIndex: 1,
                                                }}
                                              />
                                            )}
                                            <Typography
                                              sx={{
                                                fontWeight: 700,
                                                color: "#ffd700",
                                                minWidth: 20,
                                              }}>
                                              {opt}:
                                            </Typography>
                                            <Typography
                                              sx={{ color: "#fff", flex: 1 }}
                                              noWrap>
                                              {currentQuestion?.[optKey] || "—"}
                                            </Typography>
                                            {!isShown && !revealResult && (
                                              <Button
                                                size="small"
                                                variant="contained"
                                                onClick={() =>
                                                  doShowOption(opt)
                                                }
                                                sx={{
                                                  bgcolor: "#1565c0",
                                                  minWidth: 55,
                                                  fontSize: "0.75rem",
                                                }}>
                                                Show
                                              </Button>
                                            )}
                                            {isShown &&
                                              !isRevealedCorrect &&
                                              !isRevealedWrong && (
                                                <CheckIcon
                                                  sx={{
                                                    color: "#4caf50",
                                                    fontSize: 18,
                                                  }}
                                                />
                                              )}
                                            {isRevealedCorrect && (
                                              <Typography
                                                sx={{
                                                  color: "#4caf50",
                                                  fontWeight: 700,
                                                }}>
                                                ✓
                                              </Typography>
                                            )}
                                            {isRevealedWrong && (
                                              <Typography
                                                sx={{
                                                  color: "#ef5350",
                                                  fontWeight: 700,
                                                }}>
                                                ✗
                                              </Typography>
                                            )}
                                          </Box>
                                        </Grid>
                                      );
                                    })}
                                </Grid>
                                </>
                              );
                            })()}
                            {shownOptions.length > 0 && !revealResult && (
                              <Box
                                sx={{
                                  mt: 2,
                                  display: "flex",
                                  gap: 1,
                                  flexWrap: "wrap",
                                  alignItems: "center",
                                }}>
                                {["A", "B", "C", "D"].every((opt) =>
                                  shownOptions.includes(opt),
                                ) &&
                                  config?.question_timer_seconds > 0 &&
                                  questionTimerValue == null && (
                                    <Button
                                      variant="contained"
                                      size="small"
                                      startIcon={<TimeIcon />}
                                      onClick={doStartTimer}
                                      sx={{
                                        bgcolor: "#e65100",
                                        color: "#fff",
                                        "&:hover": { bgcolor: "#bf360c" },
                                      }}>
                                      Start Timer (
                                      {config.question_timer_seconds}s)
                                    </Button>
                                  )}
                                {session.highlighted_answer && (
                                  <Button
                                    variant="contained"
                                    size="small"
                                    onClick={doRevealAnswer}
                                    sx={{
                                      bgcolor: "#2e7d32",
                                      color: "#fff",
                                      "&:hover": { bgcolor: "#1b5e20" },
                                    }}>
                                    Reveal Answer
                                  </Button>
                                )}
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={doWalkAway}
                                  sx={{
                                    color: "#ff9800",
                                    borderColor: "#ff9800",
                                  }}>
                                  Walk Away
                                </Button>
                              </Box>
                            )}
                          </Box>
                        ) : (
                          <Box>
                            {(() => {
                              const nl = getNextLevel();
                              if (nl > maxLevel)
                                return (
                                  <Box sx={{ textAlign: "center", py: 4 }}>
                                    <TrophyIcon
                                      sx={{
                                        fontSize: 60,
                                        color: "#ffd700",
                                        mb: 2,
                                      }}
                                    />
                                    <Typography
                                      variant="h5"
                                      sx={{ color: "#ffd700" }}>
                                      Player reached the top!
                                    </Typography>
                                  </Box>
                                );
                              if (isRandom) {
                                const p = prizes.find((pr) => pr.level === nl);
                                const topicLabels =
                                  (p?.topic_ids || []).length > 0
                                    ? (p.topic_ids || [])
                                        .map(
                                          (id) =>
                                            (config?.topics || []).find(
                                              (t) => t.id === id,
                                            )?.display_name ||
                                            (config?.topics || []).find(
                                              (t) => t.id === id,
                                            )?.topic_name,
                                        )
                                        .filter(Boolean)
                                        .join(", ")
                                    : null;
                                const diffLabels =
                                  (p?.difficulty_ids || []).length > 0
                                    ? (p.difficulty_ids || [])
                                        .map(
                                          (id) =>
                                            (config?.difficulties || []).find(
                                              (d) => d.id === id,
                                            )?.level_name,
                                        )
                                        .filter(Boolean)
                                        .join(", ")
                                    : null;
                                if (quizSongs.length === 0) loadQuizSongs(nl);
                                return (
                                  <Box sx={{ py: 3 }}>
                                    <Typography
                                      sx={{
                                        color: "#fff",
                                        mb: 1,
                                        textAlign: "center",
                                      }}>
                                      Level {nl}
                                      {topicLabels
                                        ? ` • Topic: ${topicLabels}`
                                        : " • Topic: Any"}
                                      {diffLabels
                                        ? ` • ${diffLabels}`
                                        : " • Any"}
                                    </Typography>
                                    <Typography
                                      variant="subtitle2"
                                      sx={{ color: "#ffd700", mb: 1 }}>
                                      Songs from quiz_questions (Insta Quiz)
                                    </Typography>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      placeholder="Search songs..."
                                      value={mainSongSearch}
                                      onChange={(e) =>
                                        setMainSongSearch(e.target.value)
                                      }
                                      sx={{ mb: 1, ...df }}
                                    />
                                    <Box
                                      sx={{
                                        maxHeight: 200,
                                        overflowY: "auto",
                                        mb: 2,
                                        border: "1px solid #333",
                                        borderRadius: 1,
                                        p: 1,
                                        bgcolor: "#1a1a1a",
                                      }}>
                                      {(() => {
                                        const filtered = quizSongs.filter(
                                          (s) => {
                                            if (!mainSongSearch) return true;
                                            const q =
                                              mainSongSearch.toLowerCase();
                                            return (
                                              (s.name || "")
                                                .toLowerCase()
                                                .includes(q) ||
                                              (s.artist || "")
                                                .toLowerCase()
                                                .includes(q)
                                            );
                                          },
                                        );
                                        return quizSongs.length === 0 ? (
                                          <Typography
                                            sx={{
                                              color: "#888",
                                              textAlign: "center",
                                              py: 2,
                                            }}>
                                            Loading songs...
                                          </Typography>
                                        ) : filtered.length === 0 ? (
                                          <Typography
                                            sx={{
                                              color: "#888",
                                              textAlign: "center",
                                              py: 2,
                                            }}>
                                            No songs match
                                          </Typography>
                                        ) : (
                                          filtered.map((s) => (
                                            <Button
                                              key={s.songs_master_id}
                                              fullWidth
                                              variant={
                                                selectedQuizSongId ===
                                                String(s.songs_master_id)
                                                  ? "contained"
                                                  : "text"
                                              }
                                              onClick={() =>
                                                setSelectedQuizSongId((prev) =>
                                                  prev ===
                                                  String(s.songs_master_id)
                                                    ? ""
                                                    : String(s.songs_master_id),
                                                )
                                              }
                                              sx={{
                                                justifyContent: "flex-start",
                                                textTransform: "none",
                                                color:
                                                  selectedQuizSongId ===
                                                  String(s.songs_master_id)
                                                    ? "#000"
                                                    : "#fff",
                                                mb: 0.5,
                                                bgcolor:
                                                  selectedQuizSongId ===
                                                  String(s.songs_master_id)
                                                    ? "#ffd700"
                                                    : "transparent",
                                              }}>
                                              {s.image && (
                                                <Box
                                                  component="img"
                                                  src={
                                                    s.image.startsWith("http")
                                                      ? s.image
                                                      : `${API_BASE}/${s.image}`
                                                  }
                                                  sx={{
                                                    width: 28,
                                                    height: 28,
                                                    borderRadius: 0.5,
                                                    objectFit: "cover",
                                                    mr: 1,
                                                  }}
                                                />
                                              )}
                                              <Typography
                                                noWrap
                                                sx={{
                                                  flex: 1,
                                                  textAlign: "left",
                                                }}>
                                                {s.name}{" "}
                                                {s.artist
                                                  ? `— ${s.artist}`
                                                  : ""}
                                              </Typography>
                                              <Chip
                                                label={s.question_count}
                                                size="small"
                                                sx={{
                                                  bgcolor: "#333",
                                                  color: "#aaa",
                                                  fontSize: "0.7rem",
                                                }}
                                              />
                                            </Button>
                                          ))
                                        );
                                      })()}
                                    </Box>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 1,
                                      }}>
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          color: "#888",
                                          textAlign: "center",
                                          maxWidth: 420,
                                        }}>
                                        Select a song, then push — a random
                                        question is chosen from that song only.
                                      </Typography>
                                      <Button
                                        variant="contained"
                                        startIcon={<PlayIcon />}
                                        onClick={() =>
                                          pushQuizQuestion(
                                            parseInt(selectedQuizSongId, 10),
                                          )
                                        }
                                        size="large"
                                        disabled={
                                          quizSongs.length === 0 ||
                                          !selectedQuizSongId
                                        }
                                        sx={{
                                          bgcolor: "#e65100",
                                          color: "#fff",
                                          px: 4,
                                          "&:hover": { bgcolor: "#bf360c" },
                                        }}>
                                        Push Quiz Question from Selected Song
                                      </Button>
                                    </Box>
                                  </Box>
                                );
                              }
                              return (
                                <Box>
                                  <Typography sx={{ color: "#aaa", mb: 2 }}>
                                    Select question for Level {nl}:
                                  </Typography>
                                  {questions
                                    .filter((q) => q.level === nl)
                                    .map((q) => (
                                      <Button
                                        key={q.id}
                                        fullWidth
                                        variant="outlined"
                                        onClick={() => pushQuestionToGame(q.id)}
                                        sx={{
                                          mb: 0.5,
                                          justifyContent: "flex-start",
                                          textTransform: "none",
                                          color: "#fff",
                                          borderColor: "#555",
                                        }}>
                                        <Chip
                                          label={`L${q.level}`}
                                          size="small"
                                          sx={{
                                            mr: 1,
                                            bgcolor: "#4a6741",
                                            color: "#fff",
                                          }}
                                        />
                                        <Typography noWrap>
                                          {q.question_text}
                                        </Typography>
                                      </Button>
                                    ))}
                                  {questions.filter((q) => q.level === nl)
                                    .length === 0 && (
                                    <Typography
                                      sx={{
                                        color: "#ef5350",
                                        textAlign: "center",
                                        py: 2,
                                      }}>
                                      No questions for Level {nl}.
                                    </Typography>
                                  )}
                                </Box>
                              );
                            })()}
                          </Box>
                        )}
                      </Box>
                    )}

                    {/* FFF Leaderboard */}
                    {(session.status === "fff" ||
                      session.status === "fff_intro" ||
                      (session.status === "idle" &&
                        (fffLeaderboard.length > 0 || fffPlayers.length > 0))) &&
                      (() => {
                        const correctEntries = fffLeaderboard
                          .filter(
                            (e) => e.is_correct === 1 || e.is_correct === true,
                          )
                          .sort(
                            (a, b) =>
                              (a.time_taken_seconds || 999) -
                              (b.time_taken_seconds || 999),
                          );
                        const incorrectEntries = fffLeaderboard
                          .filter(
                            (e) =>
                              !(e.is_correct === 1 || e.is_correct === true),
                          )
                          .sort(
                            (a, b) =>
                              (a.time_taken_seconds || 999) -
                              (b.time_taken_seconds || 999),
                          );
                        const answeredDeviceIds = new Set(
                          fffLeaderboard.map((e) => String(e.device_id ?? "")),
                        );
                        const notPlayed = fffPlayers.filter(
                          (p) =>
                            !answeredDeviceIds.has(String(p.device_id ?? "")),
                        );
                        return (
                          <Box sx={{ mt: 3 }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                mb: 1.5,
                                flexWrap: "wrap",
                              }}>
                              <Typography
                                variant="subtitle1"
                                sx={{ color: "#29b6f6", fontWeight: 700 }}>
                                FFF Results
                              </Typography>
                              <Chip
                                label={`${fffLeaderboard.length} / ${fffPlayerCount} answered`}
                                size="small"
                                sx={{
                                  bgcolor: "rgba(41,182,246,0.12)",
                                  color: "#29b6f6",
                                  fontWeight: 600,
                                }}
                              />
                              {fffLeaderboardVisible && (
                                <Chip
                                  label="ON PLAYER SCREENS"
                                  size="small"
                                  sx={{
                                    bgcolor: "rgba(255,215,0,0.18)",
                                    color: "#ffd700",
                                    fontWeight: 700,
                                  }}
                                />
                              )}
                              {fffRoundEnded && !fffLeaderboardVisible && (
                                <Chip
                                  label={
                                    fffRoundEnded.reason === "all_answered"
                                      ? "ALL ANSWERED — REVEALING ANSWER"
                                      : "TIME UP — REVEALING ANSWER"
                                  }
                                  size="small"
                                  sx={{
                                    bgcolor: "rgba(0,230,118,0.16)",
                                    color: "#00e676",
                                    fontWeight: 700,
                                  }}
                                />
                              )}
                            </Box>
                            {session.status === "fff" && (
                              <Box
                                sx={{
                                  mb: 2,
                                  p: 1.5,
                                  borderRadius: 1,
                                  bgcolor: fffLeaderboardVisible
                                    ? "rgba(255,215,0,0.08)"
                                    : "rgba(41,182,246,0.06)",
                                  border: `1px solid ${fffLeaderboardVisible ? "rgba(255,215,0,0.35)" : "rgba(41,182,246,0.25)"}`,
                                }}>
                                <Typography
                                  sx={{
                                    color: "#ccc",
                                    fontSize: "0.8rem",
                                    mb: 1.25,
                                  }}>
                                  {fffRoundEnded && !fffLeaderboardVisible
                                    ? "Correct answer is on player screens — the leaderboard appears automatically in a few seconds."
                                    : fffTimerValue === 0
                                      ? "FFF finished. Show the leaderboard on player screens, or skip and pick Hot Seat below."
                                      : "Show Leaderboard unlocks after the FFF timer ends. You can still skip and pick Hot Seat below."}
                                </Typography>
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: 1,
                                    flexWrap: "wrap",
                                  }}>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    disabled={
                                      !fffLeaderboardVisible &&
                                      fffTimerValue !== 0
                                    }
                                    startIcon={
                                      fffLeaderboardVisible ? (
                                        <VisibilityOffIcon sx={{ fontSize: 16 }} />
                                      ) : (
                                        <LeaderboardIcon sx={{ fontSize: 16 }} />
                                      )
                                    }
                                    onClick={() =>
                                      toggleFFFLeaderboard(!fffLeaderboardVisible)
                                    }
                                    sx={{
                                      bgcolor: fffLeaderboardVisible
                                        ? "#c62828"
                                        : "#ffd700",
                                      color: fffLeaderboardVisible
                                        ? "#fff"
                                        : "#111",
                                      fontWeight: 700,
                                      textTransform: "none",
                                      "&:hover": {
                                        bgcolor: fffLeaderboardVisible
                                          ? "#b71c1c"
                                          : "#e6c200",
                                      },
                                      "&.Mui-disabled": {
                                        bgcolor: "rgba(255,215,0,0.2)",
                                        color: "rgba(0,0,0,0.38)",
                                      },
                                    }}>
                                    {fffLeaderboardVisible
                                      ? "Hide Leaderboard"
                                      : "Show Leaderboard to Players"}
                                  </Button>
                                </Box>
                              </Box>
                            )}
                            {correctEntries.length > 0 && (
                              <>
                                <Typography
                                  variant="subtitle2"
                                  sx={{ color: "#4caf50", mb: 1 }}>
                                  Correct Answers (Fastest First)
                                </Typography>
                                {correctEntries.map((entry, idx) => (
                                  <Box
                                    key={`c-${idx}`}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                      mb: 0.5,
                                      p: 1,
                                      borderRadius: 1,
                                      bgcolor:
                                        idx === 0
                                          ? "rgba(255,215,0,0.15)"
                                          : "#222",
                                    }}>
                                    <Typography
                                      sx={{
                                        color: idx === 0 ? "#ffd700" : "#fff",
                                        fontWeight: 700,
                                        minWidth: 24,
                                      }}>
                                      #{idx + 1}
                                    </Typography>
                                    <Typography sx={{ color: "#fff", flex: 1 }}>
                                      {entry.display_name}
                                    </Typography>
                                    <Chip
                                      label={
                                        entry.time_taken_seconds != null
                                          ? `${entry.time_taken_seconds}s`
                                          : "—"
                                      }
                                      size="small"
                                      sx={{
                                        bgcolor: "rgba(76,175,80,0.2)",
                                        color: "#4caf50",
                                        fontWeight: 600,
                                      }}
                                    />
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      onClick={() => selectHotSeat(entry)}
                                      startIcon={
                                        <HotSeatIcon sx={{ fontSize: 16 }} />
                                      }
                                      sx={{
                                        color: "#ffd700",
                                        borderColor: "#ffd700",
                                        textTransform: "none",
                                      }}>
                                      Hot Seat
                                    </Button>
                                  </Box>
                                ))}
                              </>
                            )}
                            {incorrectEntries.length > 0 && (
                              <>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    color: "#ef5350",
                                    mb: 1,
                                    mt: correctEntries.length > 0 ? 2 : 0,
                                  }}>
                                  Incorrect Answers
                                </Typography>
                                {incorrectEntries.map((entry, idx) => (
                                  <Box
                                    key={`i-${idx}`}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                      mb: 0.5,
                                      p: 1,
                                      borderRadius: 1,
                                      bgcolor: "#1a1a1a",
                                    }}>
                                    <Typography
                                      sx={{
                                        color: "#888",
                                        fontWeight: 400,
                                        minWidth: 24,
                                      }}>
                                      #{correctEntries.length + idx + 1}
                                    </Typography>
                                    <Typography sx={{ color: "#aaa", flex: 1 }}>
                                      {entry.display_name}
                                    </Typography>
                                    <Chip
                                      label={
                                        entry.time_taken_seconds != null
                                          ? `${entry.time_taken_seconds}s`
                                          : "—"
                                      }
                                      size="small"
                                      sx={{
                                        bgcolor: "rgba(239,83,80,0.15)",
                                        color: "#ef5350",
                                        fontWeight: 600,
                                      }}
                                    />
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      onClick={() => selectHotSeat(entry)}
                                      startIcon={
                                        <HotSeatIcon sx={{ fontSize: 16 }} />
                                      }
                                      sx={{
                                        color: "#ffd700",
                                        borderColor: "#ffd700",
                                        textTransform: "none",
                                      }}>
                                      Hot Seat
                                    </Button>
                                  </Box>
                                ))}
                              </>
                            )}
                            {notPlayed.length > 0 && (
                              <>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    color: "#ff9800",
                                    mb: 1,
                                    mt:
                                      correctEntries.length > 0 ||
                                      incorrectEntries.length > 0
                                        ? 2
                                        : 0,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}>
                                  <PersonOffIcon sx={{ fontSize: 16 }} /> Not
                                  answered yet — online ({notPlayed.length})
                                </Typography>
                                {notPlayed.map((p, idx) => (
                                  <Box
                                    key={`np-${String(p.device_id)}-${idx}`}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                      mb: 0.5,
                                      p: 1,
                                      borderRadius: 1,
                                      bgcolor: "#2a1f0a",
                                      border:
                                        "1px solid rgba(255,152,0,0.28)",
                                    }}>
                                    <Typography
                                      sx={{
                                        color: "#888",
                                        fontWeight: 400,
                                        minWidth: 24,
                                      }}>
                                      —
                                    </Typography>
                                    <Typography
                                      sx={{
                                        color: "#ffcc80",
                                        flex: 1,
                                        fontWeight: 600,
                                      }}>
                                      {p.display_name}
                                    </Typography>
                                    <Chip
                                      label="Waiting"
                                      size="small"
                                      sx={{
                                        bgcolor: "rgba(255,152,0,0.12)",
                                        color: "#ff9800",
                                        fontWeight: 600,
                                      }}
                                    />
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      onClick={() =>
                                        selectHotSeat({
                                          device_id: p.device_id,
                                          display_name: p.display_name,
                                        })
                                      }
                                      startIcon={
                                        <HotSeatIcon sx={{ fontSize: 16 }} />
                                      }
                                      sx={{
                                        color: "#ffd700",
                                        borderColor: "#ffd700",
                                        textTransform: "none",
                                      }}>
                                      Hot Seat
                                    </Button>
                                  </Box>
                                ))}
                              </>
                            )}
                          </Box>
                        );
                      })()}
                  </Paper>
                  {session.status === "main_game" &&
                    revealResult?.is_correct &&
                    !gameOverAdmin && (
                      <Box
                        sx={{
                          mt: 2,
                          textAlign: "center",
                          display: "flex",
                          gap: 1.5,
                          justifyContent: "center",
                          flexWrap: "wrap",
                        }}>
                        {isRandom ? (
                          <>
                            <Button
                              variant="contained"
                              onClick={handleNextQuizSameSong}
                              disabled={!currentQuestion?.songs_master_id}
                              sx={{
                                bgcolor: "#2e7d32",
                                color: "#fff",
                                fontWeight: 700,
                                "&:hover": { bgcolor: "#1b5e20" },
                              }}>
                              Next Question (Same Song)
                            </Button>
                            <Button
                              variant="contained"
                              onClick={handleNextQuizNewSong}
                              sx={{
                                bgcolor: "#e65100",
                                color: "#fff",
                                fontWeight: 700,
                                "&:hover": { bgcolor: "#bf360c" },
                              }}>
                              Next Question (Pick Song)
                            </Button>
                          </>
                        ) : (
                          <Button
                            variant="contained"
                            onClick={() => {
                              handleNextQ();
                              setRevealResult(null);
                            }}
                            sx={{
                              bgcolor: "#ffd700",
                              color: "#000",
                              fontWeight: 700,
                            }}>
                            Next Question
                          </Button>
                        )}
                      </Box>
                    )}

                  {gameOverAdmin && (
                    <Paper
                      sx={{
                        mt: 2,
                        p: 3,
                        bgcolor:
                          gameOverAdmin.reason === "won"
                            ? "#0a2a0a"
                            : gameOverAdmin.reason === "walkaway"
                              ? "#1a2a1a"
                              : "#2a1a1a",
                        border: `2px solid ${gameOverAdmin.reason === "won" ? "#ffd700" : gameOverAdmin.reason === "walkaway" ? "#4caf50" : "#ef5350"}`,
                        textAlign: "center",
                      }}>
                      {gameOverAdmin.reason === "won" ? (
                        <>
                          <Typography sx={{ fontSize: "2.5rem", mb: 0.5 }}>🏆</Typography>
                          <Typography
                            variant="h4"
                            sx={{ color: "#ffd700", fontWeight: 800, mb: 0.5 }}>
                            WINNER!
                          </Typography>
                          <Typography
                            variant="h5"
                            sx={{ color: "#fff", fontWeight: 700, mb: 0.5 }}>
                            {gameOverAdmin.winner_name || session?.hot_seat_display_name || "Player"}
                          </Typography>
                          <Typography sx={{ color: "#4fc3f7", mb: 1.5 }}>
                            Conquered all {gameOverAdmin.winning_level} levels!
                          </Typography>
                          {gameOverAdmin.prize_won && (
                            <Box sx={{ bgcolor: "rgba(255,215,0,0.12)", border: "1px solid rgba(255,215,0,0.4)", borderRadius: 2, p: 2, mb: 1.5 }}>
                              <Typography sx={{ color: "#ffd700", fontWeight: 700, fontSize: "1.1rem" }}>
                                Top Prize: {gameOverAdmin.prize_won.label}
                              </Typography>
                              {gameOverAdmin.prize_won.value_text && (
                                <Typography sx={{ color: "#4fc3f7", fontSize: "0.9rem" }}>
                                  {gameOverAdmin.prize_won.value_text}
                                </Typography>
                              )}
                            </Box>
                          )}
                        </>
                      ) : (
                        <>
                          <Typography
                            variant="h5"
                            sx={{
                              color:
                                gameOverAdmin.reason === "walkaway"
                                  ? "#4caf50"
                                  : "#ef5350",
                              fontWeight: 700,
                              mb: 1,
                            }}>
                            {gameOverAdmin.reason === "wrong"
                              ? "Wrong Answer!"
                              : gameOverAdmin.reason === "timer"
                                ? "Time's Up!"
                                : "Walked Away"}
                          </Typography>
                          {gameOverAdmin.correct_answer && (
                            <Typography sx={{ color: "#fff", mb: 1 }}>
                              Correct Answer:{" "}
                              <strong style={{ color: "#4caf50" }}>
                                {gameOverAdmin.correct_answer}
                              </strong>
                            </Typography>
                          )}
                          {gameOverAdmin.winning_level > 0 ? (
                            <Box sx={{ mt: 1 }}>
                              <Typography sx={{ color: "#ffd700", mb: 0.5 }}>
                                Prize Level: {gameOverAdmin.winning_level}
                              </Typography>
                              {gameOverAdmin.prize_won && (
                                <Typography
                                  sx={{ color: "#ffd700", fontWeight: 700 }}>
                                  {gameOverAdmin.prize_won.label} —{" "}
                                  {gameOverAdmin.prize_won.value_text}
                                </Typography>
                              )}
                            </Box>
                          ) : (
                            <Typography sx={{ color: "#888" }}>
                              No prize won
                            </Typography>
                          )}
                        </>
                      )}
                      <Button
                        variant="contained"
                        onClick={() => {
                          setGameOverAdmin(null);
                          setSession(null);
                          setCurrentQuestion(null);
                          setRevealResult(null);
                        }}
                        sx={{
                          mt: 2,
                          bgcolor: "#ffd700",
                          color: "#000",
                          fontWeight: 700,
                        }}>
                        New Game
                      </Button>
                    </Paper>
                  )}
                </Grid>

                {/* Right */}
                <Grid
                  item
                  xs={12}
                  md={3}
                  sx={{ order: { xs: 4, md: 3 } }}>
                  <Paper sx={{ p: 2, bgcolor: "#1a1a1a" }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "#ffd700", mb: 1 }}>
                      Controls
                    </Typography>
                    <Button
                      fullWidth
                      variant="contained"
                      color="error"
                      startIcon={<StopIcon />}
                      onClick={endGame}
                      sx={{ mb: 1 }}>
                      End Game
                    </Button>
                    <Divider sx={{ my: 1, borderColor: "#333" }} />
                    <Typography
                      variant="caption"
                      sx={{ color: "#888" }}>
                      Session #{session.id}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: "#888", display: "block" }}>
                      Mode: {isRandom ? "Random" : "Pre-select"}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: "#888", display: "block" }}>
                      Status: {session.status}
                    </Typography>
                    {session.hot_seat_display_name && (
                      <Typography
                        variant="caption"
                        sx={{ color: "#ffd700", display: "block" }}>
                        Hot Seat: {session.hot_seat_display_name}
                      </Typography>
                    )}
                    <Typography
                      variant="caption"
                      sx={{ color: "#888", display: "block" }}>
                      Level: {session.current_level || 0}
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            )}
          </Box>
  );
};

export default BeerillionerHostTab;
